// Get the modal by class name
var modal = document.querySelector(".products-menu");

// Get all links with href="#products"
var productLinks = document.querySelectorAll('a[href="#products"]');

// Function to open the modal with fade-in effect
function openModal() {
  modal.classList.add('active');
}

// Function to close the modal with fade-out effect
function closeModal() {
  modal.classList.remove('active');
  setTimeout(function() {
  }, 500);
}

// Loop through all links and attach hover event listeners
productLinks.forEach(function(link) {
  link.addEventListener('mouseenter', openModal);
});

// Keep modal open while hovering
modal.addEventListener('mouseenter', openModal);

// Close modal when the mouse leaves both the link and the modal
modal.addEventListener('mouseleave', closeModal);
productLinks.forEach(function(link) {
  link.addEventListener('mouseleave', function() {
    // Add a slight delay to allow moving from link to modal without closing
    setTimeout(function() {
      if (!modal.matches(':hover')) {
        closeModal();
      }
    }, 100);
  });
});